import QBreadcrumbItem from '../breadcrumb/src/breadcrumb-item';


export default QBreadcrumbItem;
